<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>

        <v-card-text>
          <!-- text field -->
          <v-text-field
            v-if="editedItem.type == 'textField'"
            v-model="editedItem.settingValue"
            label="Value"
          />
          <!-- textArea -->
          <v-textarea
            v-if="editedItem.type == 'textArea'"
            v-model="editedItem.settingValue"
          />
          <!-- currency -->
          <v-currency-field
            v-if="editedItem.type == 'currency'"
            v-model="editedItem.settingValue"
            label="Amount"
          />
          <!-- int -->
          <v-text-field
            v-if="editedItem.type == 'int'"
            v-model="editedItem.settingValue"
            mask="###"
            label="Value"
          />
          <!-- date -->
          <v-date-picker
            v-else-if="editedItem.type == 'date'"
            v-model="editedItem.settingValue"
          />
          <!-- bool -->
          <v-switch
            v-else-if="editedItem.type == 'bool'"
            :label="editedItem.settingName"
            v-model="editedItem.settingValue"
          />

        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="close"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="save"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="personGroupSettings"
      hide-actions
      class="elevation-1"
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td>{{ props.item.settingName }}</td>
        <td>{{ props.item.settingDescription }}</td>
        <td>
          <template v-if="props.item.type == 'date'">
            {{ props.item.settingValue.substring(5) }}
          </template>
          <template v-else>
            {{ props.item.settingValue }}
          </template>
        </td>
        <td class="justify-center layout px-0">
          <IconButton
            icon="fa-edit"
            tooltip="Edit"
            @click="editItem(props.item)"
          />
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import vuex mapping
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    personGroup: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      dialog: false,
      headers: [
        {
          text: 'Name',
          value: 'settingName',
          sortable: true
        },
        {
          text: 'Description',
          sortable: false
        },
        {
          text: 'Value',
          sortable: false
        },
        {
          text: 'Actions',
          sortable: false
        }
      ],
      editedIndex: -1,
      editedItem: {
        value: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      personGroups: 'person/personGroups',
      personGroupSettings: 'settings/groupSettings'
    })
  },
  watch: {
    personGroup: function (personGroup) {
      this.getPersonGroupSettings({ personGroupID: personGroup })
    }
  },
  mounted () {
    // load person groups and then set the working group
    this.getPersonGroups().then((response) => {
      this.getPersonGroupSettings({ personGroupID: this.personGroup })
    })
  },
  methods: {
    ...mapActions({
      getPersonGroupSettings: 'settings/getGroupSettings',
      getPersonGroups: 'person/getPersonGroups',
      updateGroupSetting: 'settings/updateGroupSetting'
    }),
    editItem (item) {
      // convert to boolean if necessary
      if (item.type === 'bool') {
        item.settingValue = Boolean(Number(item.settingValue))
      }
      this.editedIndex = this.personGroupSettings.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      let setting = {
        settingID: this.personGroupSettings[this.editedIndex].settingID,
        settingValue: this.editedItem.settingValue,
        personGroupID: this.personGroup
      }
      this.updateGroupSetting(setting)
      this.close()
    }
  }
}
</script>
